import * as React from 'react';
import { matchRoutes, useLocation, RouteObject } from 'react-router-dom';
import { useCafe } from '@cafe/react';
import { DEFAULT_NAVIGATION_EVENT_CATEGORY } from './app.constants';
import { pick } from './shared/utils';

export type RoutingEventParams = {
  eventName: string;
  tagsFromParams?: string[];
};

export function useSendEventOnRouteChange(
  routes: RouteObject[],
  events: Record<string, RoutingEventParams>
) {
  const location = useLocation();
  const eventingService = useCafe();

  React.useEffect(() => {
    const matches = matchRoutes(routes, location);

    if (matches) {
      const matchPath = '/' + matches.map((m) => m.route.path).join('/');
      const eventParams = events[matchPath];

      if (eventParams) {
        let tags = undefined;

        if (eventParams.tagsFromParams?.length) {
          const routeParams = matches.reduce((next, m) => {
            return { ...next, ...m.params };
          }, {});

          tags = pick(routeParams, eventParams.tagsFromParams);
        }

        eventingService.recordActivity({
          eventAction: eventParams.eventName,
          eventCategory: DEFAULT_NAVIGATION_EVENT_CATEGORY,
          tags,
        });
      }
    }
  }, [eventingService, events, location, routes]);
}
